<div class="container mt-3">
  <ng-container *ngIf="gamesGroup$ | async as gamesGroup">
    <ng-container *ngIf="gamesGroup.length > 0; else noGame">
      <fgb-leaderboard [toShow]="10" [LeaderboardType]="LeaderboardType"></fgb-leaderboard> </ng-container
  ></ng-container>
  <ng-template #noGame>
    <div class="d-flex align-items-center justify-content-center no-game-card">
      {{ 'fgbcl.game.no.trivia.game.available.text' | translate }}
    </div>
  </ng-template>
</div>
